import { useState } from "react";
import { WidgetPreview } from "./WidgetPreview";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * Widget Preview Playground
 *
 * A test page for trying out widget previews by entering a canonical widget ID.
 */
export function WidgetPreviewPlayground() {
  const [widgetId, setWidgetId] = useState("");

  return (
    <div className="flex flex-col h-full p-6 gap-6">
      <div>
        <h1 className="text-2xl font-bold mb-2">Widget Preview Playground</h1>
        <p className="text-sm text-muted-foreground">
          Enter a canonical widget ID to preview the widget in the sandbox.
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="widgetId">Canonical Widget ID</Label>
        <Input
          id="widgetId"
          type="text"
          value={widgetId}
          onChange={(e) => setWidgetId(e.target.value)}
          placeholder="e.g., jh71234567890abcdef"
          className="max-w-md"
        />
      </div>

      {widgetId && (
        <div className="flex-1 overflow-hidden">
          <WidgetPreview canonicalWidgetId={widgetId} />
        </div>
      )}
    </div>
  );
}
